import Vue from 'vue';
import VueRouter from 'vue-router';
import { tokenService } from '@/services/TokenService';
import { workspaceAccessService } from '@/services/WorkspaceAccessService';
import { storeService } from '@/services/StoreService';
import { clientDataService } from '@/services/ClientDataService';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "Index" */ '../pages/Index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "Login" */ '../pages/Login.vue'),
    meta: {},
  },
  {
    path: '/reset-pass',
    component: () => import(/* webpackChunkName: "ResetPassword" */ '../pages/forgotten-pass/ResetPassword.vue'),
    meta: {},
  },
  {
    path: '/resend-pass',
    component: () => import(/* webpackChunkName: "ResendPassword" */ '../pages/forgotten-pass/ResendPassword.vue'),
    meta: {},
  },
  {
    path: '/reset-password/:token',
    component: () => import(/* webpackChunkName: "SetNewPassword" */ '../pages/forgotten-pass/SetNewPassword.vue'),
    meta: {},
  },
  {
    path: '/logout',
    component: () => import(/* webpackChunkName: "Logout" */ '../pages/Logout.vue'),
    meta: {},
  },
  {
    path: '/registration',
    component: () => import(/* webpackChunkName: "Registration" */ '../pages/activation/Registration.vue'),
    meta: {},
  },
  {
    path: '/activate/:token',
    component: () => import(/* webpackChunkName: "ActivationCode" */ '../pages/activation/ActivationCode.vue'),
    meta: {},
  },
  {
    path: '/invitation/:token',
    component: () => import(/* webpackChunkName: "Invitation" */ '../pages/activation/Invitation.vue'),
    meta: {},
  },
  {
    path: '/vpn_client/:vpnUserUuid',
    component: () => import(/* webpackChunkName: "Invitation" */ '../pages/vpnClientDownload.vue'),
    meta: {},
  },
  {
    path: '/workspaces/:workspaceId/delete/:token',
    component: () => import(/* webpackChunkName: "WorkspaceSwitch" */ '../pages/activation/ChoosePaymentMethod.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspace-switch',
    component: () => import(/* webpackChunkName: "WorkspaceSwitch" */ '../pages/workspace/WorkspaceSwitch.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/new-workspace/intro',
    component: () => import(/* webpackChunkName: "NewWorkspace" */ '../pages/workspace/NewWorkspace.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/new-workspace',
    component: () => import(/* webpackChunkName: "NewWorkspace" */ '../pages/workspace/NewWorkspace.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/intro',
    component: () => import(/* webpackChunkName: "Workspace" */ '../pages/workspace/Workspace.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/cardActivated',
    component: () => import(/* webpackChunkName: "Workspace" */ '../pages/workspace/Workspace.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId',
    component: () => import(/* webpackChunkName: "Workspace" */ '../pages/workspace/Workspace.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/intro',
    component: () => import(/* webpackChunkName: "RegionAutoSelector" */ '../pages/workspace/RegionAutoSelector.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/cardActivated',
    component: () => import(/* webpackChunkName: "RegionAutoSelector" */ '../pages/workspace/RegionAutoSelector.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId',
    component: () => import(/* webpackChunkName: "RegionAutoSelector" */ '../pages/workspace/RegionAutoSelector.vue'),
    meta: { requiresAuth: true },
  },
  // settings
  {
    path: '/workspaces/:workspaceId/settings',
    component: () => import(/* webpackChunkName: "Settings" */ '../pages/settings/Settings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/report',
    component: () => import(/* webpackChunkName: "Report" */ '../pages/settings/Report.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/billing',
    component: () => import(/* webpackChunkName: "Billing" */ '../pages/settings/Billing.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/billing/card_verification/:status',
    component: () => import(/* webpackChunkName: "Billing" */ '../pages/settings/Billing.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/users',
    component: () => import(/* webpackChunkName: "Users" */ '../pages/settings/Users.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/new-user',
    component: () => import(/* webpackChunkName: "NewUser" */ '../pages/settings/NewUser.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/logs',
    component: () => import(/* webpackChunkName: "Logs" */ '../pages/settings/Logs.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/account-settings',
    component: () => import(/* webpackChunkName: "AccountSettings" */ '../pages/settings/AccountSettings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/confirm-email/:token',
    component: () => import(/* webpackChunkName: "ActivationCode" */ '../pages/settings/ChangeEmailConfirmation.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/account-details',
    component: () => import(/* webpackChunkName: "AccountDetails" */ '../pages/settings/AccountDetails.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/public-IP-addresses',
    component: () => import(/* webpackChunkName: "PublicIPAddressesList" */ '../pages/PublicIPAddressesList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/public-IP-addresses/:publicIpAddressId',
    component: () => import(/* webpackChunkName: "PublicIPAddress" */ '../pages/PublicIPAddress.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/private-networks',
    component: () => import(/* webpackChunkName: "PrivateNetworksList" */ '../pages/PrivateNetworksList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/private-networks/:privateNetworkType/:privateNetworkId',
    component: () => import(/* webpackChunkName: "PrivateNetwork" */ '../pages/PrivateNetwork.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/vpn',
    component: () => import(/* webpackChunkName: "Vpn" */ '../pages/Vpn.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/firewall',
    component: () => import(/* webpackChunkName: "Firewall" */ '../pages/Firewall.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/new-virtual-machine',
    component: () => import(/* webpackChunkName: "NewVirtualMachine" */ '../pages/NewVirtualMachine.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/virtual-machine-edit/:virtualMachineId',
    component: () => import(/* webpackChunkName: "VirtualMachineEdit" */ '../pages/VirtualMachineEdit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/virtual-machine-edit/:virtualMachineId/tab/:tabId',
    component: () => import(/* webpackChunkName: "VirtualMachineEdit" */ '../pages/VirtualMachineEdit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/virtual-machine-edit/:virtualMachineId/tab/:tabId/itemId/:itemId',
    component: () => import(/* webpackChunkName: "VirtualMachineEdit" */ '../pages/VirtualMachineEdit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/dedicated-machines-list',
    component: () => import(/* webpackChunkName: "DedicatedMachinesList" */ '../pages/DedicatedMachinesList.vue'),
    meta: { requiresAuth: true },
  },

  {
    path: '/workspaces/:workspaceId/regions/:regionId/choose-dedicated-machine',
    component: () => import(/* webpackChunkName: "ChooseDedicatedMachine" */ '../pages/ChooseDedicatedMachine.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/dedicated-machines/:dedicatedMachineId',
    component: () => import(/* webpackChunkName: "NewDedicatedMachine" */ '../pages/NewDedicatedMachine.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/dedicated-machine-edit/:dedicatedMachineId',
    component: () => import(/* webpackChunkName: "DedicatedMachineEdit" */ '../pages/DedicatedMachineEdit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path:
      '/workspaces/:workspaceId/regions/:regionId/dedicated-machine-edit/:dedicatedMachineId/tab/:tabId/itemId/:itemId',
    component: () => import(/* webpackChunkName: "VirtualMachineEdit" */ '../pages/DedicatedMachineEdit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/regions/:regionId/help-form',
    component: () => import(/* webpackChunkName: "HelpForm" */ '../pages/HelpForm.vue'),
    meta: { requiresAuth: true },
  },
  // TODO: fix paths below
  {
    path: '/workspaces/:workspaceId/select-payment-method',
    component: () =>
      import(/* webpackChunkName: "ChoosePaymentMethod" */ '../pages/activation/ChoosePaymentMethod.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/trial-activation',
    component: () => import(/* webpackChunkName: "TrialActivation" */ '../pages/activation/TrialActivation.vue'),
    meta: { requiresAuth: true },
  },
  // {
  //   path: '/workspaces/:workspaceId/trial',
  //   component: () => import(/* webpackChunkName: "Trial" */ '../pages/activation/Trial.vue'),
  //   meta: { requiresAuth: true },
  // },
  {
    path: '/workspaces/:workspaceId/promocode-trial',
    component: () => import(/* webpackChunkName: "Trial" */ '../pages/activation/PromocodeTrial.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/credit-card',
    component: () => import(/* webpackChunkName: "CreditCard" */ '../pages/activation/CreditCard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/workspaces/:workspaceId/credit-card/:status',
    component: () => import(/* webpackChunkName: "CreditCard" */ '../pages/activation/CreditCard.vue'),
    meta: { requiresAuth: true },
  },
  // not found
  {
    path: '*',
    component: () => import(/* webpackChunkName: "NotFound" */ '../pages/NotFound.vue'),
    meta: {},
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!tokenService.getToken()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (
    !!to.params.workspaceId &&
    (!!to.params.regionId ||
      to.fullPath.indexOf('/settings') !== -1 ||
      to.fullPath.indexOf('/billing') !== -1 ||
      to.fullPath.indexOf('/users') !== -1 ||
      to.fullPath.indexOf('/logs') !== -1)
  ) {
    workspaceAccessService.isWorkspaceActive(to.params.workspaceId).then(state => {
      if (state) {
        if (!!to.params.virtualMachineId && !!to.params.regionId) {
          storeService.getVirtualMachineListForWorkspace(to.params.workspaceId, to.params.regionId).then(() => {
            const machine = storeService.getWorkspaceMachine(
              parseInt(to.params.virtualMachineId, 10),
              to.params.workspaceId,
              to.params.regionId
            );
            if (machine) {
              next();
            } else {
              next(`/workspaces/${to.params.workspaceId}/regions/${to.params.regionId}`);
            }
          });
        } else {
          if (!!to.params.publicIpAddressId) {
            workspaceAccessService
              .isPublicIpAddressActive(to.params.workspaceId, to.params.regionId, to.params.publicIpAddressId)
              .then(state => {
                if (state) {
                  next();
                } else {
                  next(`/workspaces/${to.params.workspaceId}/regions/${to.params.regionId}/public-ip-addresses`);
                }
              });
          } else {
            if (!!to.params.privateNetworkId) {
              workspaceAccessService
                .isPrivateNetworkActive(to.params.workspaceId, to.params.regionId, to.params.privateNetworkId)
                .then(state => {
                  if (state) {
                    next();
                  } else {
                    next(`/workspaces/${to.params.workspaceId}/regions/${to.params.regionId}/private-networks`);
                  }
                });
            } else {
              next();
            }
          }
        }
      } else {
        if (!!tokenService.getToken()) {
          next(`/workspaces/${to.params.workspaceId}/select-payment-method`);
        } else {
          next();
        }
      }
    });
  } else {
    if (!!to.params.workspaceId && to.fullPath.indexOf('/credit-card') !== -1) {
      clientDataService
        .getClientData(to.params.workspaceId)
        .then(state => {
          if (!!state.contract) {
            next(`/workspaces/${to.params.workspaceId}/404`);
          } else {
            next();
          }
        })
        .catch(() => {
          next();
        });
    } else {
      next();
    }
  }
});

router.afterEach((to, from) => {
  if (to.params.workspaceId) {
    (window as any).VueGlobal.$store.commit('currentWorkspace/setWorkspaceId', to.params.workspaceId);
  }
  if (to.params.regionId) {
    (window as any).VueGlobal.$store.commit('currentWorkspace/setRegionId', to.params.regionId);
  }
  if (to.params.workspaceId) {
    (window as any).VueGlobal.$store.dispatch('currentWorkspace/getWorkspaceUserRole');
    (window as any).VueGlobal.$store.dispatch('regions/getRegions');
  }
});

export default router;
